import type { Todo } from '~/types/common'
import { MutationKey } from '~/types/mutation-key'
import { QueryKey } from '~/types/query-key'

export const apiBaseUrl = import.meta.env.VITE_API_BASE_URL

type IdParams = { id: string }

export const apiEndpoint = {
  query: {
    [QueryKey.PROFILE]: () => '/auth/me',
    [QueryKey.NG_WORDS]: () => '/admin/ng-words',
    [QueryKey.CATEGORY_APPLICATIONS]: () => '/admin/category-applications',
    [QueryKey.CATEGORY_APPLICATION_DETAIL]: (params: IdParams) => `/admin/category-applications/${params.id}`,
    [QueryKey.SERVICE_PACKAGES]: () => '/admin/service-packages',
    [QueryKey.CATEGORY_REQUESTS]: () => '/admin/category-requests',
    [QueryKey.CATEGORY_REQUEST_DETAIL]: (params: IdParams) => `/admin/category-requests/${params.id}`,
    [QueryKey.ADMIN_USERS]: () => '/admin/users',
    [QueryKey.ADMIN_USER_DETAIL]: (params: IdParams) => `/admin/users/${params.id}`,
    [QueryKey.SKILLS]: () => '/admin/skills',
    [QueryKey.SCHOOLS]: () => '/admin/schools',
    [QueryKey.ADMIN_REFERRALS_SUMMARY]: () => '/admin/referrals/summary',
    [QueryKey.ADMIN_REFERRAL_DETAIL]: (params: IdParams) => `/admin/referrals/${params.id}`,
  } as Record<QueryKey, (idParams?: Todo) => string>,
  mutation: {
    [MutationKey.LOGIN]: () => '/auth/login',
    [MutationKey.REFRESH_TOKEN]: () => '/auth/refresh-token',
    [MutationKey.CREATE_NG_WORD]: () => '/admin/ng-words',
    [MutationKey.UPDATE_NG_WORD]: (params: IdParams) => `/admin/ng-words/${params.id}`,
    [MutationKey.DELETE_NG_WORD]: (params: IdParams) => `/admin/ng-words/${params.id}`,
    [MutationKey.TOGGLE_NG_WORD]: (params: IdParams) => `/admin/ng-words/${params.id}/toggle`,
    [MutationKey.APPROVE_APPLICATION]: (params: IdParams) => `/admin/category-applications/${params.id}/approve`,
    [MutationKey.REJECT_APPLICATION]: (params: IdParams) => `/admin/category-applications/${params.id}/reject`,
    [MutationKey.CREATE_SERVICE_PACKAGE]: () => '/admin/service-packages',
    [MutationKey.UPDATE_SERVICE_PACKAGE]: (params: IdParams) => `/admin/service-packages/${params.id}`,
    [MutationKey.DELETE_SERVICE_PACKAGE]: (params: IdParams) => `/admin/service-packages/${params.id}`,
    [MutationKey.APPROVE_CATEGORY_REQUEST]: (params: IdParams) => `/admin/category-requests/${params.id}/approve`,
    [MutationKey.REJECT_CATEGORY_REQUEST]: (params: IdParams) => `/admin/category-requests/${params.id}/reject`,
    [MutationKey.UPDATE_USER_ROLE]: (params: IdParams) => `/admin/users/${params.id}/role`,
    [MutationKey.UPDATE_USER_EMAIL_VERIFIED]: (params: IdParams) => `/admin/users/${params.id}/email-verified`,
    [MutationKey.GRANT_USER_POINTS]: (params: IdParams) => `/admin/users/${params.id}/grant-points`,
    [MutationKey.CREATE_SKILL]: () => '/admin/skills',
    [MutationKey.UPDATE_SKILL]: (params: IdParams) => `/admin/skills/${params.id}`,
    [MutationKey.DELETE_SKILL]: (params: IdParams) => `/admin/skills/${params.id}`,
    [MutationKey.UPLOAD_SKILL_ICON]: (params: IdParams) => `/admin/skills/${params.id}/icon`,
    [MutationKey.CREATE_SCHOOL]: () => '/admin/schools',
    [MutationKey.UPDATE_SCHOOL]: (params: IdParams) => `/admin/schools/${params.id}`,
    [MutationKey.IMPORT_SCHOOLS_CSV]: () => '/admin/schools/import',
    [MutationKey.SYNC_SCHOOL_MIRRORS]: () => '/admin/schools/sync-mirrors',
  } as Record<MutationKey, (idParams?: Todo) => string>,
}
